import { Container } from '@plone/components';
import type { Content } from '@plone/types';
import { FormattedMessage } from 'react-intl';

const Colophon = ({ content }: { content: Content }) => {
  return (
    <Container className="colophon">
      <>
        <div className="powered-by">
          <FormattedMessage
            id="powered_by"
            defaultMessage="Our service is based on the open source version of Nextcloud. Nextcloud is  a registered trademark of Nextcloud GmbH. Portknox.net is an independent hosting provider and is not affiliated with Nextcloud GmbH."
          />
        </div>
      </>
    </Container>
  );
};

export default Colophon;
